import { useAuthBearerFetch } from "matsuri-hooks"
import { Company } from "@/domain/company"
import { m2mCleaning } from "@/endpoints/m2m-cleaning"

export const useAssignableCompanies = (token: string) => {
    const endpoint = m2mCleaning.managerV4.listAssignableCompanies

    return useAuthBearerFetch<Company[]>(token, endpoint(), {
        method: endpoint.method
    })
}
